import Grid from '@mui/material/Grid2'
import { DayContainer, DayLabel } from "./styled";
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACE } from './i18n';


interface Props {
    weekDayIndex: number
}

export function DayOfWeek(props: Props){
    const {
        weekDayIndex
    } = props
    
    const { t } = useTranslation(I18N_NAMESPACE)
    
    return (
        <Grid size={'auto'}>
            <DayContainer>
                <DayLabel 
                    sx={{
                        fontSize: '12px',
                        fontWeight: 700,
                        color: '#9e9e9e'
                    }}
                >
                    {t(`days.${weekDayIndex}`)[0]}
                </DayLabel>
            </DayContainer>
        </Grid>
    )
}